export default __webpack_public_path__ + "static/media/memo-recap-Brainstorming.c6b46823.xlsx";